var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDeleteWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14285 7.85721C9.1153 7.85721 10.7143 6.25823 10.7143 4.28578C10.7143 2.31334 9.1153 0.714355 7.14285 0.714355C5.1704 0.714355 3.57141 2.31334 3.57141 4.28578C3.57141 6.25823 5.1704 7.85721 7.14285 7.85721Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28568 17.857H0.714233V17.0826C0.725606 15.9937 1.01277 14.9255 1.54891 13.9777C2.08505 13.0299 2.85267 12.2335 3.78005 11.6628C4.70746 11.092 5.76437 10.7657 6.85208 10.7142C6.94905 10.7096 7.04599 10.7072 7.14282 10.707C7.23965 10.7072 7.33661 10.7096 7.43358 10.7142C8.52128 10.7657 9.5782 11.092 10.5056 11.6628C11.0389 11.9909 11.5193 12.3937 11.9333 12.8571",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1428 16.4287H19.2857",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDeleteWhite);
export default __webpack_public_path__ + "static/media/user_delete-white.90ae64794a0c96e81e991af37541dcf3.svg";
export { ForwardRef as ReactComponent };